export const siteEntries = [
  {
    id: 1,
    name: '禁漫天堂官方主站',
    url: 'https://jmcomic1.me',
    status: '可用',
    speed: '极速',
    description: '禁漫天堂官方主域名，提供最稳定的访问体验，推荐首选使用。',
    type: 'official',
  },
  {
    id: 2,
    name: '禁漫天堂备用入口一',
    url: 'https://jmcomic2.cc',
    status: '可用',
    speed: '快速',
    description: '禁漫天堂第一备用域名，当主站访问缓慢时可切换使用。',
    type: 'official',
  },
  {
    id: 3,
    name: '禁漫天堂镜像站 A',
    url: 'https://18comic.vip',
    status: '可用',
    speed: '稳定',
    description: '禁漫天堂官方镜像站点，内容实时同步更新。',
    type: 'mirror',
  },
  {
    id: 4,
    name: '禁漫天堂镜像站 B',
    url: 'https://18comic.org',
    status: '可用',
    speed: '快速',
    description: '禁漫天堂官方镜像站点，适合部分地区用户访问。',
    type: 'mirror',
  },
  {
    id: 5,
    name: '禁漫天堂加速节点一',
    url: 'https://jmcomic1.art',
    status: '可用',
    speed: '极速',
    description: '禁漫天堂CDN加速节点，提供高速访问体验。',
    type: 'cdn',
  },
  {
    id: 6,
    name: '禁漫天堂加速节点二',
    url: 'https://jmcomic2.art',
    status: '维护中',
    speed: '待恢复',
    description: '禁漫天堂CDN加速节点，目前正在维护升级中。',
    type: 'cdn',
  },
];

export const latestArticles = [
  {
    id: 1,
    title: '禁漫天堂2026年最新可用入口汇总',
    excerpt: '本文整理了2026年禁漫天堂所有可用的访问入口，包括官方主站、镜像站点及加速节点，帮助读者快速找到最稳定的访问方式。',
    category: '访问指南',
    date: '2026-08-01',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20manga%20reading%20platform%20interface%20with%20digital%20comic%20panels%2C%20warm%20amber%20lighting%2C%20minimalist%20design%2C%20japanese%20illustration%20style%20blended%20with%20modern%20UI%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=500&seq=article-cover-01&orientation=landscape',
    content: '',
  },
  {
    id: 2,
    title: '如何解决禁漫天堂打不开的问题',
    excerpt: '遇到禁漫天堂无法访问的情况？本文详细介绍DNS优化、代理设置、浏览器配置等多种解决方案，助你快速恢复访问。',
    category: '访问指南',
    date: '2026-07-28',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Digital%20network%20connection%20troubleshooting%20concept%20with%20abstract%20geometric%20patterns%2C%20warm%20golden%20and%20amber%20tones%2C%20modern%20tech%20aesthetic%2C%20clean%20minimal%20design%2C%20soft%20lighting&width=800&height=500&seq=article-cover-02&orientation=landscape',
    content: '',
  },
  {
    id: 3,
    title: '禁漫天堂APP下载与使用全攻略',
    excerpt: '禁漫天堂官方APP支持Android和iOS双平台，本文详细介绍下载安装步骤、功能介绍及使用技巧，让移动端阅读体验更流畅。',
    category: '使用教程',
    date: '2026-07-25',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20digital%20manga%20reader%20app%20interface%2C%20warm%20ambient%20lighting%2C%20modern%20mobile%20device%20on%20wooden%20desk%2C%20japanese%20illustration%20style%2C%20clean%20minimal%20aesthetic%2C%20soft%20shadows&width=800&height=500&seq=article-cover-03&orientation=landscape',
    content: '',
  },
  {
    id: 4,
    title: '禁漫天堂会员权益与订阅指南',
    excerpt: '了解禁漫天堂VIP会员的各项专属权益，包括去广告、高清画质、提前阅读等特权，选择最适合你的订阅方案。',
    category: '使用教程',
    date: '2026-07-20',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20with%20golden%20card%20on%20dark%20elegant%20background%2C%20warm%20luxurious%20gold%20and%20amber%20tones%2C%20minimalist%20design%2C%20sophisticated%20aesthetic%2C%20soft%20golden%20lighting&width=800&height=500&seq=article-cover-04&orientation=landscape',
    content: '',
  },
];

export const categories = [
  {
    id: 'all',
    name: '全部',
    icon: 'ri-apps-2-line',
    description: '浏览全部漫画分类',
  },
  {
    id: 'romance',
    name: '恋爱',
    icon: 'ri-heart-line',
    description: '甜蜜浪漫的恋爱题材漫画',
  },
  {
    id: 'fantasy',
    name: '奇幻',
    icon: 'ri-magic-line',
    description: '充满想象力的奇幻世界',
  },
  {
    id: 'action',
    name: '动作',
    icon: 'ri-flashlight-line',
    description: '热血刺激的动作漫画',
  },
  {
    id: 'comedy',
    name: '喜剧',
    icon: 'ri-emotion-laugh-line',
    description: '轻松搞笑的喜剧漫画',
  },
  {
    id: 'drama',
    name: '剧情',
    icon: 'ri-movie-line',
    description: '引人入胜的剧情向漫画',
  },
  {
    id: 'slice-of-life',
    name: '日常',
    icon: 'ri-sun-line',
    description: '温馨治愈的日常故事',
  },
  {
    id: 'mystery',
    name: '悬疑',
    icon: 'ri-search-eye-line',
    description: '扣人心弦的悬疑推理',
  },
];

export const mangaList = [
  {
    id: 1,
    title: '秘密花园',
    author: '樱花漫社',
    category: 'romance',
    rating: 4.8,
    chapters: 86,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20cover%20art%20style%2C%20romantic%20couple%20silhouette%20in%20garden%20setting%2C%20warm%20soft%20colors%20amber%20and%20rose%20tones%2C%20japanese%20illustration%2C%20clean%20minimal%20composition%2C%20beautiful%20lighting&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '在繁华都市的一隅，隐藏着一座不为外人所知的秘密花园。两位年轻人在此相遇，展开一段温馨动人的恋爱故事。',
  },
  {
    id: 2,
    title: '异世界冒险谭',
    author: '星辰创作',
    category: 'fantasy',
    rating: 4.9,
    chapters: 152,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20art%20style%2C%20adventurer%20with%20sword%20in%20magical%20forest%2C%20warm%20golden%20and%20emerald%20accents%2C%20japanese%20illustration%2C%20clean%20composition%2C%20mystical%20lighting&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '普通上班族意外穿越到剑与魔法的世界，凭借现代知识在异世界展开惊险刺激的冒险旅程。',
  },
  {
    id: 3,
    title: '校园风暴',
    author: '风暴漫画',
    category: 'action',
    rating: 4.7,
    chapters: 64,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Action%20manga%20cover%20art%20style%2C%20dynamic%20school%20fight%20scene%20silhouette%2C%20warm%20amber%20and%20crimson%20tones%2C%20japanese%20illustration%2C%20clean%20bold%20composition%2C%20dramatic%20lighting&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '在看似平静的校园中，隐藏着不为人知的势力争斗。主角凭借过人实力，一步步揭开校园背后的秘密。',
  },
  {
    id: 4,
    title: '每日一笑',
    author: '欢乐漫画',
    category: 'comedy',
    rating: 4.6,
    chapters: 120,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20manga%20cover%20art%20style%2C%20funny%20exaggerated%20character%20expressions%2C%20warm%20cheerful%20orange%20and%20yellow%20tones%2C%20japanese%20illustration%2C%20playful%20composition%2C%20bright%20lighting&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '四个性格迥异的高中生聚在一起，每天都在上演令人捧腹的搞笑日常，轻松解压必备之选。',
  },
  {
    id: 5,
    title: '时光之隙',
    author: '时光工作室',
    category: 'drama',
    rating: 4.9,
    chapters: 48,
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=Drama%20manga%20cover%20art%20style%2C%20melancholic%20character%20looking%20at%20sunset%2C%20warm%20amber%20and%20soft%20rose%20tones%2C%20japanese%20illustration%2C%20emotional%20composition%2C%20golden%20hour%20lighting&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '一封来自十年前的信，让主角踏上寻找过去的旅程。穿越时光的思念与重逢，感人至深的故事。',
  },
  {
    id: 6,
    title: '咖啡与猫',
    author: '猫薄荷社',
    category: 'slice-of-life',
    rating: 4.7,
    chapters: 36,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Slice%20of%20life%20manga%20cover%20art%2C%20cozy%20cafe%20with%20cat%20and%20barista%2C%20warm%20creamy%20and%20brown%20tones%2C%20japanese%20illustration%2C%20gentle%20composition%2C%20soft%20natural%20lighting&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '街角的小小咖啡馆里，老板与三只猫咪的温馨日常。每一杯咖啡都承载着一个温暖的小故事。',
  },
  {
    id: 7,
    title: '暗夜追踪者',
    author: '黑夜漫画',
    category: 'mystery',
    rating: 4.8,
    chapters: 72,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20cover%20art%20style%2C%20detective%20silhouette%20in%20dark%20alley%2C%20warm%20amber%20highlights%20on%20dark%20background%2C%20japanese%20illustration%2C%20suspenseful%20composition%2C%20noir%20lighting&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '黑夜中隐藏着无数谜团，天才侦探凭借敏锐观察力与缜密推理，将一个个悬案真相大白于天下。',
  },
  {
    id: 8,
    title: '花与梦',
    author: '花间漫画',
    category: 'romance',
    rating: 4.5,
    chapters: 96,
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Romance%20manga%20cover%20art%2C%20beautiful%20character%20among%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20amber%20tones%2C%20japanese%20illustration%2C%20delicate%20composition%2C%20dreamy%20spring%20lighting&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '花艺师与画家的浪漫邂逅，在繁花盛开的小镇展开一段如诗如画的爱情故事。',
  },
];

export const faqList = [
  {
    id: 1,
    question: '禁漫天堂是什么？',
    answer: '禁漫天堂是一个专注于成人漫画在线阅读的综合平台，拥有海量正版漫画资源，涵盖恋爱、奇幻、动作、喜剧等多种题材，为用户提供流畅的在线阅读体验和丰富的漫画内容。',
  },
  {
    id: 2,
    question: '如何找到禁漫天堂最新可用的网址？',
    answer: '您可以通过以下方式获取最新可用入口：(1) 收藏本页面，我们会实时更新所有可用域名；(2) 关注禁漫天堂官方社交媒体账号获取最新通知；(3) 使用禁漫天堂官方APP，APP会自动切换可用服务器。',
  },
  {
    id: 3,
    question: '禁漫天堂是否免费？',
    answer: '禁漫天堂提供免费阅读和VIP会员两种模式。免费用户可以阅读大部分漫画内容，VIP会员可享受去广告、高清画质、提前解锁新章节等专属权益。具体订阅方案请参考会员权益页面。',
  },
  {
    id: 4,
    question: '禁漫天堂支持哪些设备访问？',
    answer: '禁漫天堂支持多种设备访问：(1) PC端通过浏览器直接访问；(2) Android手机可下载官方APP；(3) iOS手机可通过Safari浏览器访问或下载官方APP；(4) 平板设备同样支持上述方式。所有设备均提供适配的阅读界面。',
  },
  {
    id: 5,
    question: '为什么有时候禁漫天堂打不开？',
    answer: '禁漫天堂偶尔可能出现访问不稳定的情况，常见原因包括：(1) 域名DNS解析问题，可尝试切换DNS服务器；(2) 网络运营商限制，建议使用代理或VPN；(3) 服务器临时维护，请稍后再试。建议收藏多个备用入口以备不时之需。',
  },
  {
    id: 6,
    question: '如何注册禁漫天堂账号？',
    answer: '注册禁漫天堂账号非常简单：(1) 访问禁漫天堂任意可用入口；(2) 点击右上角"注册"按钮；(3) 输入邮箱地址并设置密码；(4) 完成邮箱验证即可。注册后即可收藏漫画、订阅更新通知。',
  },
  {
    id: 7,
    question: '禁漫天堂的内容是否为正版？',
    answer: '禁漫天堂与多家漫画出版社和创作团队建立了合作关系，平台上的漫画内容均经过正版授权。我们致力于为创作者提供合理的收益回报，同时为读者带来优质的阅读体验。',
  },
  {
    id: 8,
    question: '如何联系禁漫天堂客服？',
    answer: '您可以通过以下方式联系客服：(1) 发送邮件至官方客服邮箱；(2) 在网站或APP内使用在线客服功能；(3) 通过官方社交媒体账号私信。客服工作时间为工作日9:00-18:00，我们会在24小时内回复您的咨询。',
  },
];

export const aboutInfo = {
  brandName: '禁漫天堂在线',
  founded: '2018年',
  slogan: '汇聚精品漫画，畅享阅读乐趣',
  introduction: '禁漫天堂在线成立于2018年，是国内领先的成人漫画在线阅读平台。我们致力于为漫画爱好者提供丰富、优质、正版的漫画内容，打造极致的在线阅读体验。经过多年发展，禁漫天堂已积累了数百万注册用户和海量漫画资源，成为行业内的标杆品牌。',
  mission: '让每一位漫画爱好者都能便捷地获取优质漫画内容，享受阅读的乐趣。我们不断优化平台体验，拓展内容资源，为用户创造更好的阅读环境。',
  team: '禁漫天堂拥有专业的内容运营团队、技术研发团队和客户服务团队，团队成员均具有丰富的互联网和动漫行业经验，共同为用户提供优质服务。',
  reputation: [
    { label: '注册用户', value: '500万+' },
    { label: '漫画资源', value: '10万+' },
    { label: '日均访问', value: '200万+' },
    { label: '用户好评率', value: '98%' },
  ],
  contact: {
    email: 'support@jmcomic.com',
    wechat: 'JMComic_Official',
    weibo: '@禁漫天堂官方',
    workingHours: '工作日 9:00 - 18:00',
    address: '中国上海市浦东新区张江高科技园区',
  },
};